import request from "@/service";

/* 班级分组管理分页 */
export function managePage(data) {
  return request({
    url: "/study/class/group/managePage",
    method: "get",
    params: data,
  });
}

/* 分组管理-班组名称 */
export function groupNames(data) {
  return request({
    url: "/study/class/group/queryRequire",
    method: "get",
    params: data,
  });
}

/* 班级分组管理移动学员 */
export function moveGroup(data) {
  return request({
    url: "/study/class/group/MoveGroup",
    method: "post",
    data,
  });
}

/* 班级分组管理设置组长 */
export function groupManageUpdate(data) {
  return request({
    url: "/study/class/group/groupManageUpdate",
    method: "post",
    data,
  });
}

/* 分组管理-查询条件 */
export function queryCondition(data) {
  return request({
    url: "/study/class/group/queryCondition",
    method: "post",
    data,
  });
}

/* 班级分组管理移动学员 */
export function groupManageDrag(data) {
  return request({
    url: "/study/class/group/groupManageDrag",
    method: "post",
    data,
  });
}

/* 班级分组列表导入 */
export function importGroup(data) {
  return request({
    url: "/study/class/group/importGroup",
    method: "post",
    data,
  });
}

/* 小班-班级分组导入 */
export function importSmall(data) {
  return request({
    url: "/study/class/group/importSmall",
    method: "post",
    data,
  });
}

/* 班级分组学员列表导出 */
export function exportGroup(data) {
  return request({
    url: "/study/class/group/exportGroup",
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data,
  });
}

// 小班-班级分组学员导出
export function exportSmallClassGroup(data) {
  return request({
    url: "/study/class/group/exportSmallClassGroup",
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data,
  });
}

// 小班管理-小班名称
export function smallClassName(params) {
  return request({
    url: "/study/classOffline/info/smallClassName",
    method: "get",
    params,
  });
}

// 小班管理-新增小班
export function saveSmallClass(data) {
  return request({
    url: "/study/classOffline/info/saveSmallClass",
    method: "post",
    data,
  });
}
// 小班管理-小班列表
export function smallClassList(params) {
  return request({
    url: "/study/classOffline/info/smallClassList",
    method: "get",
    params,
  });
}

// 小班管理-拖拽排序
export function SmallClassDrag(data) {
  return request({
    url: "/study/classOffline/info/SmallClassDrag",
    method: "post",
    data,
  });
}

// 小班管理-删除小班
export function delSmallClass(data) {
  return request({
    url: "/study/classOffline/info/delSmallClass",
    method: "post",
    data,
  });
}

// 小班管理-编辑小班
export function updateSmallClass(data) {
  return request({
    url: "/study/classOffline/info/updateSmallClass",
    method: "post",
    data,
  });
}

// 小班管理学员列表返回时判断是否有学员未分班
export function noSmallClassEnroll(params) {
  return request({
    url: "/study/classOffline/enroll/noSmallClassEnroll",
    method: "get",
    params,
  });
}

// 分组管理查是否有小班
export function haveSmallClass(params) {
  return request({
    url: `/study/class/group/haveSmallClass`,
    method: "get",
    params
  });
}

// 班级分组-轮训班(党校专题研讨班)
export function specialPage(params) {
  return request({
    url: `/study/class/group/specialPage`,
    method: "get",
    params
  });
}

/* 联络员和自习室导入 */
export function importLiaison(data) {
  return request({
    url: "/study/class/group/importLiaison",
    method: "post",
    data,
  });
}


/**********************联络员管理**************************/

export function liaisonPage(params) {
  return request({
    url: `/study/class/group/liaisonPage`,
    method: "get",
    params
  });
}

export function saveLiaisons(data) {
  return request({
    url: "/study/class/group/saveLiaison",
    method: "post",
    data,
  });
}

export function liaisonInfo(uuid) {
  return request({
    url: `/study/class/group/infoLiaison/${uuid}`,
    method: "get",
  });
}

export function updateLiaisonInfo(data) {
  return request({
    url: "/study/class/group/updateLiaison",
    method: "post",
    data,
  });
}

export function deleteLiaisons(data) {
  return request({
    url: "/study/class/group/deleteLiaison",
    method: "post",
    data,
  });
}
// 导出联络员
export function exportLiaisons(data) {
  return request({
    url: "/study/class/group/exportLiaison",
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data,
  });
}
// 拖拽排序
export function dragLiaisons(data) {
  return request({
    url: "/study/class/group/dragLiaison",
    method: "post",
    data,
  });
}

export function graduationLiaisons(data) {
  return request({
    url: "/study/class/group/graduationLiaison",
    method: "post",
    data,
  });
}

// 

export function liaisonTrainDays(params) {
  return request({
    url: `/study/class/group/liaisonLeaveDays`,
    method: "get",
    params
  });
}







